module.exports = __webpack_public_path__ + "img/contact_icon_left_menu.4d11f5e7.svg";